import React from 'react';
import PropTypes from 'prop-types';
import PaginationLinks from 'shared/components/PaginationLinks';
import LoadingContent from 'shared/components/LoadingContent';

const ReferralsTable = ({
  numPages,
  currentPage,
  fetch,
  fetching,
  refresh,
  referrals,
  emptyMessage,
  searchTerm,
  tableComponent,
}) => {
  if (!fetching && (!referrals || referrals.length < 1)) {
    return (
      <div className="well">
        <p>{emptyMessage}</p>
      </div>
    );
  }
  return (
    <div>
      {fetching && !referrals ? (
        <LoadingContent />
      ) : (
        <div>
          {/* <PaginationLinks
            pageNum={currentPage}
            onPageClick={desiredPageNum => fetch(desiredPageNum, searchTerm)}
            totalPages={numPages}
          /> */}
          {React.createElement(tableComponent, { referrals, refresh })}
          <PaginationLinks
            pageNum={currentPage}
            onPageClick={desiredPageNum => fetch(desiredPageNum, searchTerm)}
            totalPages={numPages}
          />
        </div>
      )}
    </div>
  );
};

ReferralsTable.propTypes = {
  numPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  fetch: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
  refresh: PropTypes.func.isRequired,
  referrals: PropTypes.array.isRequired,
  emptyMessage: PropTypes.string.isRequired,
  tableComponent: PropTypes.func.isRequired, // functional component
};

export default ReferralsTable;
